import dynamic from 'next/dynamic';

import { useShouldHideUserAccountExclusiveContent } from '@/hooks/useShouldHideUserAccountExclusiveContent';
import { useListing } from '@/hooks/queries/useListing';

const PropertyDetails = dynamic(() =>
  import('@/components/property-expose/PropertyDetails/PropertyDetails').then((mod) => mod.PropertyDetails),
);

export const DynamicPropertyDetails = () => {
  const isUAExclusiveListingAndNotSignedIn = useShouldHideUserAccountExclusiveContent();
  const {
    data: { listing },
  } = useListing();

  if (!listing || isUAExclusiveListingAndNotSignedIn) return null;

  return <PropertyDetails listing={listing} />;
};
